module.exports = __webpack_public_path__ + "img/image-19.2d9bd9ee.webp";